module.exports = __webpack_public_path__ + "img/logo45px.35717dd4.svg";